import React from "react";
import { Popover as AntdPopover } from "antd";

const Popover = (props) => {
  return <AntdPopover {...props} />;
};

export default Popover;
